import { useState } from "react";
import { PartnersSheet } from "./PartnersSheet";
import { PrivacyPolicySheet } from "./PrivacyPolicySheet";
import { PartnersDialog } from "./PartnersDialog";
import { PrivacyPolicyDialog } from "./PrivacyPolicyDialog";

export type ObjectionSheet = "partners" | "privacy";

/**
 * The sheet the objection screen at signup (O1) opens over itself, if any. One at a time. The state lives with the page that mounts the
 * screen, so leaving the page (a browser Back included) discards it.
 */
export function useObjectionSheets(): {
  openSheet: ObjectionSheet | null;
  open: (sheet: ObjectionSheet) => void;
  close: () => void;
} {
  const [openSheet, setOpenSheet] = useState<ObjectionSheet | null>(null);
  return {
    openSheet,
    open: setOpenSheet,
    close: () => {
      setOpenSheet(null);
    },
  };
}

/**
 * The two sheets of the objection screen, mounted next to it: bottom sheets on
 * a phone, dialogs on a desktop (Figma D7).
 */
export function PartnerObjectionSheets({
  layout,
  openSheet,
  onClose,
}: {
  layout: "mobile" | "desktop";
  openSheet: ObjectionSheet | null;
  onClose: () => void;
}): React.JSX.Element | null {
  switch (layout) {
    case "mobile":
      return (
        <>
          <PartnersSheet isOpen={openSheet === "partners"} onClose={onClose} />
          <PrivacyPolicySheet
            isOpen={openSheet === "privacy"}
            onClose={onClose}
          />
        </>
      );
    case "desktop":
      switch (openSheet) {
        case null:
          return null;
        case "partners":
          return <PartnersDialog onClose={onClose} />;
        case "privacy":
          return <PrivacyPolicyDialog onClose={onClose} />;
        default:
          throw new Error(openSheet satisfies never);
      }
    default:
      throw new Error(layout satisfies never);
  }
}
